import Task from './Task'
import React, { useContext } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import styled from 'styled-components'

import Action from '~/types/action'
import tasksContext from '~/contexts/tasks/tasksContext'
import colors from '~/styles/colors'
import { radius } from '~/styles/vars'
import { boolean } from 'yargs'

const TasksList: React.FC = () => {
    const { state, dispatch } = useContext(tasksContext)

    const handleDragEnd = (order: any) => {
        if (!order.destination) return
        const destinationId = order.destination.index
        const sourceId = order.source.index

        dispatch({
            type: 'reorder_task',
            data: { sourceIndex: sourceId, destinationIndex: destinationId }
        } as Action)
        console.log('reorder done')
    }

    return state.tasks.length ? (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="tasks">
                {(provided, snapshot) => (
                    <List {...provided.droppableProps} ref={provided.innerRef} isDragging={snapshot.isDraggingOver}>
                        {state.tasks.map((task, i) => {
                            return (
                                <Draggable
                                    key={`task_${i}`}
                                    draggableId={`draggable_${i}`}
                                    index={i}
                                >
                                    {provided => (
                                        <ListItem
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <Task {...task} key={task.id} />
                                        </ListItem>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </List>
                )}
            </Droppable>
        </DragDropContext>
    ) : (
        <Empty>Vous n'avez pas encore de tâches</Empty>
    )
}

const Empty = styled.h2`
    color: ${colors.main[300]};
`

const List = styled.ul<{isDragging : boolean}>`
    padding: 5rem 0 10rem 0;
    border-radius: ${radius.sm};
    list-style: none;
    transition: 0.25s;
    background-color: ${({isDragging}) => isDragging ? '#232731' : 'none' };
`

const ListItem = styled.li`
    list-style: none;
    display: flex;
`

export default TasksList
